var LeafletDrawUtil = /** @class */ (function () {
    function LeafletDrawUtil() {
    }
    /**
     * Deep copy the source object into the dest object. Will only copy literal values.
     * @param dest
     * @param src
     */
    LeafletDrawUtil.deepLiteralCopy = function (dest, src) {
        var toReturn = dest;
        if (null != src) {
            for (var k in src) {
                if (src.hasOwnProperty(k)) {
                    if (typeof (src[k]) === 'string' || src[k] instanceof String) {
                        toReturn[k] = src[k];
                    }
                    else {
                        this.deepLiteralCopy(toReturn[k], src[k]);
                    }
                }
            }
        }
        return toReturn;
    };
    return LeafletDrawUtil;
}());
export { LeafletDrawUtil };
//# sourceMappingURL=leaflet-draw.util.js.map